import { IDeserialize } from "./abstraction/IDeserialize";
import { TechCoverContact } from "./TechCoverContact";

export class TechCoverContactEdit
  extends TechCoverContact
  implements IDeserialize<TechCoverContactEdit>
{
  // Client-side only
  isEditing = false;
  isItemLoading = false;
  modifiedEmail: string;
  modifiedPhone: string;

  deserialize(dto: TechCoverContact): TechCoverContactEdit {
    if (!dto) return this;
    Object.assign(this, dto);
    return this;
  }
}
